import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowdown",
  "use": "arrowdown-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10 6\" id=\"arrowdown\">\n<path d=\"M5.031,5.984c-0.254,0-0.508-0.096-0.703-0.289L0.313,1.728C-0.08,1.339-0.083,0.706,0.305,0.313\n\tc0.389-0.392,1.022-0.396,1.415-0.008l3.306,3.268l3.251-3.262C8.667-0.08,9.299-0.083,9.69,0.308\n\tc0.391,0.39,0.393,1.023,0.002,1.414L5.739,5.69C5.544,5.886,5.287,5.984,5.031,5.984z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol